import { createContext } from 'react';
export var currencyContextDefaultValue = {
    imxClient: undefined,
    tokens: undefined,
    queue: undefined,
    ctaTokenUsdRate: 0,
    usdcAddress: undefined,
    parseCurrencyQuantity: function () { return ({}); },
    parseCurrencyQuantityNumber: function () { return ({}); },
};
export var CurrencyContext = createContext(currencyContextDefaultValue);
